import { z } from "zod";
export const agentPromptKindSchema = z.enum([
    "task_agent_base",
    "provider_plugin_bridge",
    "non_provider_plugin_bridge",
    "answer_style",
    "triage_brief",
]);
export const agentPromptSurfaceSchema = z.object({
    kind: agentPromptKindSchema,
    promptId: z.string().trim().min(1),
    promptSlug: z.string().trim().min(1),
    versionId: z.string().trim().min(1),
    version: z.number().int().positive(),
    body: z.string().trim().min(1),
    hash: z.string().trim().min(1),
});
